// removed by extract-text-webpack-plugin
module.exports = {"root":"Icon__root__2C7y","small":"Icon__small__2pul","medium":"Icon__medium__2Tck","large":"Icon__large__1qe7"};